/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../../../../infra/hooks';
import { reportsToService } from '../../../../api/services/reportsToService';
import ReporterType from '../../../../infra/aggregates/reportsToInterface';
import {
  reportsToReducer,
  setReporterLoader,
} from '../../../../infra/aggregates/reportsToSlice';
import {
  myTeamReducer,
  setMyTeamLoading,
} from '../../../../infra/aggregates/myTeamSlice';
import { myTeamService } from '../../../../api/services/myTeamService';

interface PropsValues {
  setReporterData: (data: ReporterType) => void;
  setTeamMembers: (data: any) => void;
}
function DTOReporter({ setReporterData, setTeamMembers }: PropsValues) {
  const dispatch = useAppDispatch();
  const selector = useAppSelector((state) => state);

  let reporter: ReporterType = {
    emp_pic: '',
    emp_name: '',
    emp_designation: '',
    manager_award: '',
  };
  async function getManager(companyId: number, empId: number) {
    dispatch(setReporterLoader(true));
    await reportsToService
      .reportsTo(companyId, empId)
      .then((response: any) => {
        let award = '';
        if (response?.data?.user_role?.user?.employee?.awards?.length) {
          award =
            response?.data?.user_role?.user?.employee?.awards[0]?.description;
        }
        reporter = {
          emp_pic: response.data?.user_role?.user?.profile_pic,
          emp_name: response.data?.user_role?.user?.name,
          emp_designation: response.data?.manager_designation,
          manager_award: award,
        };
        dispatch(setReporterLoader(false));
        dispatch(reportsToReducer(reporter));
        setReporterData(reporter);
      })
      .catch((err) => {
        dispatch(setReporterLoader(false));
        console.log(err);
      });
  }

  async function getMyTeam(
    companyId: number,
    departmentId: number,
    emp_id: number,
    user_id: number,
  ) {
    dispatch(setMyTeamLoading(true));

    if (departmentId && (emp_id || user_id))
      await myTeamService
        .myTeam(companyId, departmentId, emp_id, user_id)
        .then((response: any) => {
          dispatch(setMyTeamLoading(false));
          dispatch(myTeamReducer(response?.data));
          setTeamMembers(response?.data);
        })
        .catch((err) => {
          dispatch(setMyTeamLoading(false));
          console.log(err);
        });
  }
  useEffect(() => {
    const companyId = selector.authSlice.company_id;
    const dept_id = selector.authSlice.department_id;
    const emp_id = selector.authSlice.emp_id;
    const user_id = selector.authSlice.user_id;
    getMyTeam(companyId, dept_id, emp_id, user_id);
    getManager(companyId, selector.authSlice.emp_id);
  }, []);

  useEffect(() => {
    const company_id = selector.authSlice.company_id;
    const dept_id = selector.authSlice.department_id;
    const emp_id = selector.authSlice.emp_id;
    const user_id = selector.authSlice.user_id;
    getMyTeam(company_id, dept_id, emp_id, user_id);
  }, [selector.authSlice.department_id]);

  return <></>;
}
export default DTOReporter;
